import React, {useEffect} from "react";
import {Skeleton} from "antd";
import {PageHeader} from '@ant-design/pro-layout';
import PDFComponent from "../../components/PDFComponent";
// import { useAuth } from "../../context/AuthContext";
import config from "../../business/config.json"
import {useParams} from "react-router-dom";
import {useAxios} from "../../hooks/hooks";

function ReportPage(props) {
    const {id} = useParams();
    return (<>
            <PageHeader
                title={<>
                    <span>Report</span>&nbsp;
                </>}
                style={{padding: 0, paddingBottom: 16}}
                extra={[]}
            />
            <PDFComponent
                file={"/business/database/project/latex/hazmat/" + (props.id ? props.id : id) + "/document.pdf"}
            />
        </>);
}

export default ReportPage;
